import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function Markdown({ children, testId }) {
  return (
    <div data-testid={testId} className="prose-report">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: (p) => <h1 className="font-display text-3xl" {...p} />,
          h2: (p) => <h2 className="font-display text-2xl" {...p} />,
          h3: (p) => <h3 className="font-display text-xl" {...p} />,
          p: (p) => <p className="my-3 leading-relaxed text-[hsl(var(--clinic-muted))]" {...p} />,
          ul: (p) => <ul className="my-3 list-inside list-disc space-y-1 text-[hsl(var(--clinic-muted))]" {...p} />,
          ol: (p) => <ol className="my-3 list-inside list-decimal space-y-1 text-[hsl(var(--clinic-muted))]" {...p} />,
          blockquote: (p) => (
            <blockquote className="my-4 border-l-4 border-[hsl(var(--clinic-secondary))] bg-[hsl(var(--clinic-bg))] px-4 py-2 italic" {...p} />
          ),
          a: (p) => <a className="text-[hsl(var(--clinic-secondary))] underline" {...p} />,
          code: (p) => <code className="rounded bg-[hsl(var(--clinic-bg))] px-1 py-0.5 font-mono text-sm" {...p} />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
